"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @file index.ts
 * @author imcuttle
 *
 */
var React = require("react");
var isPlainObj = require("is-plain-obj");
/**
 * Determine react component instance
 * @public
 * @param instance {any}
 * @return {boolean}
 * @example
 * import { isComponentInstance } from '@rcp/util.iscompclass'
 * class View extends React.Component {}
 *
 * isComponentInstance(View.prototype)
 */
function isComponentInstance(instance) {
    return !!instance && instance instanceof React.Component;
}
exports.isComponentInstance = isComponentInstance;
/**
 * Determine react component class
 * @public
 * @see [how-to-determine-if-js-object-is-react-component](https://discuss.reactjs.org/t/how-to-determine-if-js-object-is-react-component/2825/5)
 * @param component {any}
 * @return {boolean}
 */
function isComponentClass(component) {
    return ((!!component &&
        !!component.prototype &&
        !!component.prototype.isReactComponent &&
        isPlainObj(component.prototype.isReactComponent)) ||
        // legacy ?
        (!!component && !!component.prototype && isComponentInstance(component.prototype)));
}
exports.default = isComponentClass;
//# sourceMappingURL=index.js.map